/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';

import useDebounce from '../../../helpers/useDebounce';
import { getVouchers } from '../../../apis';

export const MIN_LENGTH = 6;
export const MAX_LENGTH = 16;
export const MIN_LENGTH_ERROR = `Minimum ${MIN_LENGTH} characters`;
const DUPLICATE_ERROR = 'This code is already in use';
const DEBOUNCE_MS = 400;
const ERROR_KEY = 'campaignCode';

type SetFormError = (key: string, error: string | null) => void;

export const useCampaignCodeValidation = (prefix: string, setFormError: SetFormError) => {
  const [isChecking, setIsChecking] = useState(false);
  const debouncedPrefix = useDebounce(prefix, DEBOUNCE_MS);

  useEffect(() => {
    if (prefix.length < MIN_LENGTH) {
      setFormError(ERROR_KEY, MIN_LENGTH_ERROR);
      setIsChecking(false);
    }
  }, [prefix, setFormError]);

  useEffect(() => {
    if (debouncedPrefix.length < MIN_LENGTH) return;

    let cancelled = false;
    setIsChecking(true);

    getVouchers({ limit: 20, page: 1, code: debouncedPrefix })
      .then(({ results }) => {
        if (cancelled) return;
        const exists = results.some(
          v => v.code === debouncedPrefix || v.prefix === debouncedPrefix,
        );
        setFormError(ERROR_KEY, exists ? DUPLICATE_ERROR : null);
      })
      .catch(() => {
        if (!cancelled) setFormError(ERROR_KEY, null);
      })
      .finally(() => {
        if (!cancelled) setIsChecking(false);
      });

    return () => {
      cancelled = true;
    };
  }, [debouncedPrefix, setFormError]);

  useEffect(() => () => setFormError(ERROR_KEY, null), [setFormError]);

  return { isChecking };
};
